"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartViewPanel_1 = require("./CartViewPanel");
exports.default = CartViewPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/CartViewPanel/index.js
// module id = 140
// module chunks = 8